import Container from "@client/content/Containers/container";
import { getContainerProps, getRootContainerProps } from "@client/content/lib/helper";
import Content from "@client/content/modules/OrderConfirmation/Content/component";
import { type RootContainerProps } from "@client/content/types";
import { type WithIsEditMode } from "@client/types";
import * as React from "react";
import { type OrderDetail } from "./types";

export type MapProps = RootContainerProps &
  WithIsEditMode & {
    isDownloading: boolean;
    isEditMode: boolean;
    orderSummary: OrderDetail.OrderSummary | null;
    history: OrderDetail.OrderHistoryItem[];
    noImageUrl: string;
  };

export interface ActionProps {
  onDownload: () => void;
  onClickAddComment: () => void;
}

export default (props: ActionProps & MapProps) => (
  <Container className="wsc_content_order_detail" {...getContainerProps(props)}>
    {props.orderSummary ? (
      <Content
        {...getRootContainerProps(props)}
        isDownloading={props.isDownloading}
        isEditMode={props.isEditMode}
        history={props.history}
        noImageUrl={props.noImageUrl}
        onDownload={props.onDownload}
        orderSummary={props.orderSummary}
        onClickAddComment={props.onClickAddComment}
      />
    ) : props.isEditMode ? (
      "No order to display"
    ) : null}
  </Container>
);
